// View toggle — switches between list and card layout for hosted sites

import { List, LayoutGrid } from 'lucide-react'
import { cn } from '../../lib/utils'

interface ViewToggleProps {
  view: 'list' | 'card'
  onChange: (v: 'list' | 'card') => void
  isDark: boolean
}

export function ViewToggle({ view, onChange, isDark }: ViewToggleProps) {
  const base = cn(
    'rounded-md p-1.5 transition-colors',
    isDark
      ? 'text-neutral-400 hover:text-neutral-200'
      : 'text-neutral-400 hover:text-neutral-700',
  )
  const active = isDark
    ? 'bg-surface-3 text-neutral-200'
    : 'bg-neutral-200 text-neutral-800'

  return (
    <div
      role="group"
      aria-label="View layout"
      className={cn(
        'flex items-center rounded-lg border p-0.5',
        isDark ? 'border-white/[0.06] bg-surface-2' : 'border-neutral-200 bg-neutral-50',
      )}
    >
      <button
        type="button"
        onClick={() => onChange('list')}
        aria-pressed={view === 'list'}
        aria-label="List view"
        title="List view"
        className={cn(base, view === 'list' && active)}
      >
        <List className="h-3.5 w-3.5" />
      </button>
      <button
        type="button"
        onClick={() => onChange('card')}
        aria-pressed={view === 'card'}
        aria-label="Card view"
        title="Card view"
        className={cn(base, view === 'card' && active)}
      >
        <LayoutGrid className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
